// extracted by mini-css-extract-plugin
export var MailchimpSubscribe = "G_bD";
export var aniBgLoading = "G_f";
export var aniSpin = "G_d";
export var input = "G_bF";
export var message = "G_bJ";
export var submit = "G_bG";
export var submitBtn = "G_bH";
export var wrap = "G_bg";